


















import Vue from "vue";

import iwInputPrice from "../buildingBlocks/InputPrice.vue";
import {resetPricingPack} from "@/shared/scripts/ValidateData";

export default Vue.extend({
    components: {
        iwInputPrice: iwInputPrice
    },
    data: function() {
        return {
            pathInStore: "transaction.sale.price",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE";
        },
        price: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(price: number): void {
            if (price === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": price});
            }
            resetPricingPack();
        }
    }
});
